'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduce2 = require('./_internal/_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _reverse4 = require('./_internal/_reverse');

var _reverse5 = _interopRequireDefault(_reverse4);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _executeOn = require('./executeOn');

var _executeOn2 = _interopRequireDefault(_executeOn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); } /**
                                                                               *
                                                                               * Compose functions from right to left
                                                                               *
                                                                               * @module compose
                                                                               * @func
                                                                               * @since 1.0.0
                                                                               * @param {...function} args
                                                                               * @returns {function}
                                                                               * @example
                                                                               *
                                                                               *     compose(val => val + 1, val => val + 2); //=> val => val + 3
                                                                               */

var compose = function compose() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var _reverse2 = (0, _reverse5.default)(args),
        _reverse3 = _toArray(_reverse2),
        first = _reverse3[0],
        rest = _reverse3.slice(1);

    var callFirst = (0, _call2.default)(first);

    return function () {
        for (var _len2 = arguments.length, opts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            opts[_key2] = arguments[_key2];
        }

        return (0, _reduce3.default)(rest, _executeOn2.default, callFirst(opts));
    };
};

exports.default = compose;